<template>
<footer id="footer" class="section bg-charcoal">
    <div class="container">
        <div class="columns is-variable is-6">
            <div :class="['column', {'is-4': i == 0}]" v-for="item, i in $store.state.site_data.siteconfig.footer">
                <h3 class="title is-6">{{item.title}}</h3>
                <p class="title is-4" v-if="item.caption">{{item.caption}}</p>
                <ul class="menu-list" v-if="item.menu">
                    <li class="menu-list__item" v-for="menu_item in item.menu">
                        <router-link :to="menu_item.url">{{menu_item.title}}</router-link>
                    </li>
                </ul>
                <div class="content" v-if="item.content" v-html="item.content"></div>
                <div class="action" v-if="item.action"><router-link class="button is-primary" :to="item.action.url">{{item.action.title}}</router-link></div>
            </div>
        </div>
    </div>
</footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/Footer.vue